import { sortedCheckinJobs } from './useCheckinReminders';
export function CheckinReminders({ reminders, error, loading, onRetry }) {
    return <div className="inbox-checkins">{error ? <p className="inbox-error" role="alert">{error}{onRetry ? <button type="button" onClick={onRetry}>Retry</button> : null}</p> : null}
        {loading && !reminders.length ? <p role="status">Loading check-ins…</p> : null}
        {!loading && !error && !reminders.length ? <p className="inbox-empty">No unfinished check-ins.</p> : null}
        {reminders.map(reminder => {
            const jobs = sortedCheckinJobs(reminder);
            return <details key={reminder.id} className="inbox-reminder"><summary>
                <span><strong>{reminder.customer_name}</strong><span className="inbox-meta">{reminder.region.replace(/([a-z])([A-Z])/g, '$1 $2')} · {reminder.business_date}</span></span>
                <span className="inbox-reminder-count">{jobs.length} {jobs.length === 1 ? 'job' : 'jobs'}<span className="inbox-meta">From {jobs[0]?.check_in}</span></span>
            </summary><ul className="inbox-jobs">{jobs.map(job => <li key={job.job_id}>
                <time>{job.check_in}</time><strong>{job.address}</strong><span className="inbox-job-details"><span>{job.worker ? `Worker ${job.worker}` : 'Unassigned'}</span><span>Job {job.cos_job_id}</span></span>
            </li>)}</ul></details>;
        })}
    </div>;
}
